import { createFileRoute } from '@tanstack/react-router';
import { TransactionalListRouteView } from '@/pages/workspaces/transactional/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The Transactional list. No `appBundle`: this URL has no `journeys` segment for the resolver to
 * rebuild from.
 */
function TransactionalRoute() {
  return (
    <LastWorkspaceResolver>
      <TransactionalListRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/transactional')({
  component: TransactionalRoute,
});
